import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'

export function MenuInner() {
  const intl = useIntl()
  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.DASHBOARD'})} to='/dashboard' />
      {/* <MenuItem title='Layout Builder' to='/builder' /> */}
      <MenuInnerWithSub
        title='Admin'
        to='/admin'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MenuInnerWithSub
          title='Contractor'
          to='/admin/contractor'
          fontIcon='bi-person'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        > 
        <MenuItem to='/admin/contractor/allContractor' title='All Contractor' hasBullet={true} />
        <MenuItem to='/admin/contractor/addContractor' title='Add Contractor' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Project'
          to='/admin/project'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        > 
        <MenuItem to='/admin/project/allProject' title='All Project' hasBullet={true} />
        <MenuItem to='/admin/project/addProject' title='Add Project' hasBullet={true} />
        <MenuItem to='/admin/project/ongoingProject' title='Ongoing Project' hasBullet={true} />
        <MenuItem to='/admin/project/finishedProject' title='Finished Project' hasBullet={true} />
        <MenuItem to='/admin/project/upcomingProject' title='Upcoming Project' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Contractor Videos'
          to='/admin/contractorTrainingVideos'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        > 
        <MenuItem to='/admin/contractorTrainingVideo/AllTrainingVideo' title='All Training Video' hasBullet={true} />
        <MenuItem to='/admin/contractorTrainingVideo/AddTrainingVideo' title='Add Training Video' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Employee Videos'
          to='/admin/employeeTrainingVideos'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        > 
        <MenuItem to='/admin/employeeTrainingVideo/AllTrainingVideo' title='All Training Video' hasBullet={true} />
        <MenuItem to='/admin/employeeTrainingVideo/AddTrainingVideo' title='Add Training Video' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Map View'
          to='/admin/mapView'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        > 
        <MenuItem to='/admin/mapView/MapView' title='Map View Projects' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Calendar View'
          to='/admin/calendarView'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        > 
        <MenuItem to='/admin/calendarView/CalendarView' title='Calendar View Projects' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Master Data'
          to='/admin/masterData'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        > 
        <MenuItem to='/admin/masterData/AllRoofType' title='All Roof Type' hasBullet={true} />
        <MenuItem to='/admin/masterData/AddRoofType' title='Add Roof Type' hasBullet={true} />
        <MenuItem to='/admin/masterData/AllSubRoofType' title='All Sub Category Roof ' hasBullet={true} />
        <MenuItem to='/admin/masterData/AddSubRoofType' title='Add Sub Category Roof ' hasBullet={true} />
        </MenuInnerWithSub>

       </MenuInnerWithSub> 



   
      
      {/* <MenuInnerWithSub
        title='Crafted'
        to='/crafted'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        
        <MenuInnerWithSub
          title='Pages'
          to='/crafted/pages'
          fontIcon='bi-archive'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuInnerWithSub
            title='Profile'
            to='/crafted/pages/profile'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
            <MenuItem
              to='/crafted/pages/profile/connections'
              title='Connections'
              hasBullet={true}
            />
          </MenuInnerWithSub>
          <MenuInnerWithSub
            title='Wizards'
            to='/crafted/pages/wizards'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true} />
            <MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
          </MenuInnerWithSub>
        </MenuInnerWithSub>

        
        <MenuInnerWithSub
          title='Accounts'
          to='/crafted/accounts'
          fontIcon='bi-person'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
          <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
        </MenuInnerWithSub>

      
        <MenuInnerWithSub
          title='Errors'
          to='/error'
          fontIcon='bi-sticky'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/error/404' title='Error 404' hasBullet={true} />
          <MenuItem to='/error/500' title='Error 500' hasBullet={true} />
        </MenuInnerWithSub>

       
        <MenuInnerWithSub
          title='Widgets'
          to='/crafted/widgets'
          fontIcon='bi-layers'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
          <MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
          <MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
          <MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
          <MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
          <MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
        </MenuInnerWithSub>
      </MenuInnerWithSub> */}

      {/* <MenuInnerWithSub title='Apps' to='/apps' menuPlacement='bottom-start' menuTrigger='click'>
        
        <MenuInnerWithSub
          title='Chat'
          to='/apps/chat'
          icon='/media/icons/duotune/communication/com012.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
          <MenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
          <MenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
        </MenuInnerWithSub>
        <MenuItem
          icon='/media/icons/duotune/general/gen051.svg'
          to='/apps/user-management/users'
          title='User management'
        />
      </MenuInnerWithSub> */}

      {/* <MenuInnerWithSub
        isMega={true}
        title='Mega menu'
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MegaMenu />
      </MenuInnerWithSub> */}
    </>
  )
}
